/**
 * Returns API destination prefix
 *
 * @returns {String}
 */
export function getAPIUrl() {
  return `${window.location.origin}/api`;
}
